<template>
  <label class="fu-switch" :class="{ 'fu-switch--on': value }">
    <input
      type="checkbox"
      role="switch"
      class="fu-switch__input"
      :checked="value"
      :aria-checked="value ? 'true' : 'false'"
      v-bind="$attrs"
      @change="$emit('input', $event.target.checked)"
    />
    <span class="fu-switch__track" aria-hidden="true"><span class="fu-switch__thumb"></span></span>
    <span class="fu-switch__label">{{ label }}</span>
  </label>
</template>

<script>
/**
 * The design system's Switch (the export's chip-row switches, lines 345–354): a real checkbox with
 * role="switch", drawn as a track and thumb. v-model (value / input). Attributes (data-test,
 * aria-describedby) land on the <input>.
 */
export default {
  name: 'FollowupsSwitch',
  inheritAttrs: false,
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
@import './mixins';

.fu-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  cursor: pointer;
  min-width: 0;
}

.fu-switch__input {
  @include fu-visually-hidden;
}

.fu-switch__track {
  position: relative;
  flex: none;
  width: 36px;
  height: 20px;
  border-radius: 20px;
  background: $fu-neutral-300;
  transition: background $fu-dur-base $fu-ease-out;
}

.fu-switch__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: $fu-shadow-xs;
  transition: transform $fu-dur-base $fu-ease-out;
}

.fu-switch--on .fu-switch__track { background: $fu-brand; }
.fu-switch--on .fu-switch__thumb { transform: translateX(16px); }

.fu-switch__input:focus-visible + .fu-switch__track { box-shadow: $fu-ring; }

.fu-switch__label {
  font-size: 13.5px;
  font-weight: $fu-fw-semibold;
  color: $fu-text;
  min-width: 0;
}
</style>
